import React from 'react';
import 'pp-vx/dist/components/core/core';
import 'pp-vx/dist/components/modal/modal';
import 'pp-vx/dist/components/modal/modalAdmin';

import styles from './Modal.less';

class Modal extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.Modal = new window.PPVX.Modal(`#${this.props.id}`, true);
    if (this.props.showOnMount) {
      this.Modal.show();
    }
  }

  render() {
    return (
      <div
        className='ppvx_modal-backdrop'
        id={this.props.id}
        role='dialog'
        aria-label={this.props.titleId}
        aria-hidden='true'
      >
        <article className={`ppvx_modal ${styles['max-width']}`} tabIndex='-1'>
          <header className='ppvx_modal-header'>
            <div className='ppvx_modal-header__action' />
            <div className='ppvx_modal-header__close'>
              <button
                className='ppvx_modal-header__close-btn'
                onClick={() => {
                  this.Modal.hide();
                }}
                id='hide-my-modal'
                aria-label='close lightbox'
                tabIndex='0'
              />
            </div>
          </header>
          <section className={'ppvx_modal__contents'}>
            {React.cloneElement(this.props.children, {
              hide: () => this.Modal.hide(),
              show: () => this.Modal.show(),
            })}
          </section>
        </article>
      </div>
    );
  }
}

Modal.defaultProps = {
  showOnMount: false,
  id: 'myModal',
};

export default Modal;
